import styled from 'styled-components';
import React from 'react';
import { csrfToken } from '@/util/helpers/ajax-helpers';

const HerokuFormContainer = styled.form`
  display: none;
`;

type HerokuSetupFormProps = {
  value: string;
};
export const HerokuSetupForm = React.forwardRef<
  HTMLFormElement,
  HerokuSetupFormProps
>(({ value }, ref) => (
  <HerokuFormContainer ref={ref} method="post" action="/datasources">
    <input type="hidden" name="_csrf" value={csrfToken()} />
    <input name="database_url" type="text" value={value} />
  </HerokuFormContainer>
));
